<template>
    <div class="welcome-back-area">
        <div class="container-fluid">
            <div class="welcome-back-content">
                <span>Welcome Back</span>
                <h2>JOHN SMILGA</h2>
                <p>Your students completed 80% of the tasks.</p>

                <img class="welcome-img" src="../../../assets/images/welcome.png" alt="welcome image">
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'WelcomeBack'
}
</script>

<style lang="scss">
.welcome-back-content {
	background-image: url(../../../assets/images/welcome-bg.jpg);
	background-position: center center;
	background-repeat: no-repeat;
	background-size: cover;
	padding: 65px 50px;
	position: relative;
	margin-top: 24px;
	margin-bottom: 24px;
	border-radius: 20px;
	.welcome-img {
		position: absolute;
		right: 150px;
		bottom: 0;
	}
	span {
		color: var(--white-color);
		font-size: 12px;
		margin-bottom: 5px;
		display: block;
	}
	h2 {
		font-size: 26px;
		font-weight: 700;
		margin-bottom: 20px;
		color: var(--white-color);
		letter-spacing: 0.78px;
	}
	p {
		font-size: 14px;
		margin-bottom: 0;
		color: rgba(255, 255, 255, 0.8);
	}
}

/* Max width 767px */
@media only screen and (max-width: 767px) {
	.welcome-back-content {
        padding: 20px;
        margin-top: 0;
        margin-bottom: 24px;
        border-radius: var(--border-radius);
        .welcome-img {
            display: none;
        }
        h2 {
            margin-bottom: 15px;
            font-size: 20px;
        }
    }
}

/* Min width 768px to Max width 991px */
@media only screen and (min-width: 768px) and (max-width: 991px) {
    .welcome-back-content {
        padding: 30px;
        margin-bottom: 30px;
        border-radius: var(--border-radius);
		margin-top: 0;
        .welcome-img {
            right: 50px;
            bottom: 0;
            max-width: 134px;
        }
        h2 {
            margin-bottom: 15px;
            font-size: 20px;
        }
    }
}

/* Min width 992px to Max width 1199px */
@media only screen and (min-width: 992px) and (max-width: 1199px) {
    .welcome-back-content {
        background-size: cover;
        border-radius: 20px;
        margin-top: 0;
        margin-bottom: 30px;
        padding: 50px;
        .welcome-img {
            bottom: 0;
            right: 0;
            max-width: 190px
        }
    }
}

/* Min width 1200px to Max width 1320px */
@media only screen and (min-width: 1200px) and (max-width: 1399px) {
    .welcome-back-content {
        background-size: cover;
        border-radius: 20px;
        margin-top: 0;
        margin-bottom: 30px;
        padding: 50px;
        .welcome-img {
            bottom: 0;
            right: 18px;
            max-width: 185px;
        }
    }
}

/* Min width 1320px to Max width 1550px */
@media only screen and (min-width: 1320px) and (max-width: 1550px) {
    .welcome-back-content {
        background-size: cover;
        border-radius: 20px;
        margin-top: 30px;
        margin-bottom: 30px;
        padding: 50px;
        .welcome-img {
            bottom: 0;
            right: 0;
        }
    }
}

/* Min width 1400px to Max width 1700px */
@media only screen and (min-width: 1400px) and (max-width: 1700px) {

}

/* Min width 1119px*/
@media only screen and (max-width:1199px) {

}
</style>